export default "__VITE_ASSET__Cd2_uKak__"